//i18n-setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// import axios from 'axios'
Vue.use(VueI18n)
export const SUPPORTED_LANGUAGES={
    ru:'Russian',
    en:'English'
}
export const DEFAULT_LANGUAGE=localStorage.getItem('lang')||'ru';
export const i18n = new VueI18n({
//   locale: DEFAULT_LANGUAGE, // set locale
  fallbackLocale: DEFAULT_LANGUAGE,
//   messages // set locale messages
})
const loadedLanguages = []//Object.keys(SUPPORTED_LANGUAGES) // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  localStorage.setItem('lang',lang)
//   axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.js`).then(
    messages => {
      i18n.setLocaleMessage(lang, messages.default)
      loadedLanguages.push(lang)
      return setI18nLanguage(lang)
    }
  )
}
loadLanguageAsync(DEFAULT_LANGUAGE)